export const addDecimals = (num) => {
  return Math.round(num);
};


export const updateCart = (state) => {
  // Calculate the items price
  state.itemsPrice = addDecimals(
    state.cartItems.reduce((acc, item) => acc + item.price * item.qty, 0)
  );

  // Calculate the shipping price
  // state.shippingPrice = addDecimals(state.itemsPrice > 100 ? 0 : 10);
  state.shippingPrice = calcShippingPrice(state.shippingAddress);

  // Calculate the tax price
  state.taxPrice = 0;

  // Calculate the total price
  state.totalPrice = Math.round(
    Number(state.itemsPrice) +
    Number(state.shippingPrice) +
    Number(state.taxPrice)
  );

  // Save the cart to localStorage
  localStorage.setItem('cart', JSON.stringify(state));

  return state;
};

// This calculation also appears in the backend in utils/calcPrices.js so make sure to keep them in sync
export function calcShippingPrice(shippingAddress) {
  switch (shippingAddress.area) {
    case 'צפון':
      return 25;
    case 'חדרה, זכרון והעמקים':
      return 25;
    case 'יהודה ושומרון ובקעת הירדן':
      return 25;
    case 'שרון':
      return 25
    case 'מרכז':
      return 25
    case 'שפלה ומישור החוף הדרומי':
      return 30
    case 'מחוז ירושלים':
      return 30
    case 'דרום':
      return 30
    default:
      return 25;
  }
}